"use client"
import { getAnalyticsTopClicked } from "@/api/generated/BMWApi"
import { BaseCarModel } from "@/api/generated/BMWInterfaces"
import { Desktop, Mobile, useIsDesktop } from "@/lib/common/MediaQueries"
import { sendNoResultCarouselClick } from "@/lib/gtm"
import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { Navigation } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import CarsCard from "./CarsCard"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  ${(p) => p.theme.breakpoints.up("md")} {
    gap: 24px;
  }
`

const StyledTitle = styled(Typography)`
  font-weight: 500;
  letter-spacing: 0em;
  text-align: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-weight: 400;
  }
`

const StyledSwiperContainer = styled.div`
  width: 100%;
`

const StyledSwiper = styled(Swiper)`
  &.mySwiper {
    max-width: 100%;
    width: 100%;
    & .swiper-wrapper {
      align-items: stretch;
    }
    & .swiper-slide {
      height: auto;
    }
  }
`

const StyledGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`

const MostClickedCars = (): React.ReactElement | null => {
  const [topClicked, setTopClicked] = useState<BaseCarModel[]>([])

  const isDesktop = useIsDesktop()

  const fetchMostClickedCars = async (): Promise<BaseCarModel[]> => {
    const carsNumber = isDesktop ? 3 : 5
    try {
      const data = await getAnalyticsTopClicked(carsNumber).then((res) => res.data)
      return data?.body?.topOverallClicks?.map((model) => model.carModelInfo) || []
    } catch (error) {
      console.error("Error fetching most clicked cars:", error)
      return []
    }
  }

  useEffect(() => {
    void fetchMostClickedCars().then(setTopClicked)
  }, [])

  if (topClicked.length === 0) {
    return null
  }
  return (
    <StyledWrapper>
      <Desktop>
        <StyledTitle variant="h3">ההצעות הנצפות ביותר</StyledTitle>
      </Desktop>
      <Mobile>
        <StyledTitle variant="subtitle1">ההצעות הנצפות ביותר</StyledTitle>
      </Mobile>
      <StyledSwiperContainer>
        <Desktop>
          <StyledSwiper
            modules={[Navigation]}
            slidesPerView={3}
            spaceBetween={32}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            className="mySwiper"
          >
            {topClicked?.map((car, i) => (
              <SwiperSlide key={i}>
                <CarsCard data={car} onClick={() => sendNoResultCarouselClick(car?.name)} />
              </SwiperSlide>
            ))}
          </StyledSwiper>
        </Desktop>
        <Mobile>
          <StyledGrid>{topClicked?.map((car, i) => <CarsCard key={i} data={car} />)}</StyledGrid>
        </Mobile>
      </StyledSwiperContainer>
    </StyledWrapper>
  )
}

export default MostClickedCars
